var render = function render(){var _vm=this,_c=_vm._self._c;return _c('orders-table',{attrs:{"title":_vm.title,"orders":_vm.orders,"page":_vm.currentPage,"action":_vm.action,"click-event":_vm.clickEvent}})
}
var staticRenderFns = []

export { render, staticRenderFns }